import ObjectivesCheckboxGroup from './ObjectivesCheckboxGroup';

export default ObjectivesCheckboxGroup;
